import { Component } from '@angular/core';
import * as _ from 'underscore';
import { AlertService, Alert, AlertType } from './alert.service';
import { Subscription } from 'rxjs';


// @Directive()
@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  standalone: false
})

export class AlertComponent {
  alerts: Alert[] = [];

  private subscription!: Subscription;

  private timers = new Map<number, ReturnType<typeof setTimeout>>();

  constructor(
    private alertService: AlertService
  ) { }

  ngOnInit(): void {

    this.subscription = this.alertService
      .getAlert()
      .subscribe((alert: Alert | null) => {

        // Clear all notifications
        if (!alert) {
          this.clearAlerts();
          return;
        }

        // Add notification
        this.alerts = [...this.alerts, alert];

        // Automatic dismissal
        if (alert.duration && alert.duration > 0) {
          const timer = setTimeout(() => {
            this.removeAlert(alert);
          }, alert.duration);

          this.timers.set(alert.id, timer);
        }

      });
  }

  // Get CSS class
  cssClass(alert: Alert): string {

    const classes: Record<AlertType, string> = {
      [AlertType.Success]: 'toast-success',
      [AlertType.Error]: 'toast-danger',
      [AlertType.Info]: 'toast-info',
      [AlertType.Warning]: 'toast-warning'
    };

    return classes[alert.type] || 'toast-info';
  }

  // Get alert type
  getAlertType(alert: Alert): string {

    switch (alert.type) {
      case AlertType.Success:
        return 'success';

      case AlertType.Error:
        return 'danger';

      case AlertType.Warning:
        return 'warning';

      case AlertType.Info:
      default:
        return 'info';
    }
  }

  // Get alert title
  getAlertTitle(alert: Alert): string {

    switch (alert.type) {
      case AlertType.Success:
        return 'Success';

      case AlertType.Error:
        return 'Error';

      case AlertType.Warning:
        return 'Warning';

      case AlertType.Info:
      default:
        return 'Information';
    }
  }

  // Remove individual notification
  removeAlert(alert: Alert): void {

    const timer = this.timers.get(alert.id);

    if (timer) {
      clearTimeout(timer);
      this.timers.delete(alert.id);
    }

    this.alerts = this.alerts.filter(
      item => item.id !== alert.id
    );
  }

  // Clear all notifications
  clearAlerts(): void {

    this.timers.forEach(timer => clearTimeout(timer));

    this.timers.clear();
    this.alerts = [];
  }

  ngOnDestroy(): void {

    this.subscription?.unsubscribe();

    this.clearAlerts();
  }
}
